import { useState } from "react";

import {
  AtsIntegration,
  UnifiedIntegrationContext,
  UnifiedConfig,
} from "./UnifiedIntegrationContext";
import { TokensStep } from "./components/steps/TokensStep";
import { PackagesAndSettingsStep } from "./components/steps/PackagesAndSettingsStep";

export function UnifiedIntegrationSetupPage() {
  const [atsIntegrationData, setAtsIntegration] = useState<AtsIntegration>({
    tokens: [],
    report_url_type: "DIRECT_PDF_URL",
    default_package_id: "",
    trigger_stage: "",
    customer_group_id: "",
  });
  const [currentStep, setCurrentStep] = useState(0);
  const [unifiedConfig, setUnifiedConfig] = useState<UnifiedConfig | null>(
    null
  );

  const steps = [
    <TokensStep key="TokensStep" />,
    <PackagesAndSettingsStep key="PackagesAndSettingsStep" />,
  ];

  const goToNextStep = () => setCurrentStep((curr) => curr + 1);
  const goToPrevStep = () => setCurrentStep((curr) => curr - 1);

  return (
    <UnifiedIntegrationContext.Provider
      value={{
        atsIntegrationData,
        setAtsIntegration,
        goToNextStep,
        goToPrevStep,
        currentStep,
        unifiedConfig,
        setUnifiedConfig,
      }}
    >
      {steps[currentStep]}
    </UnifiedIntegrationContext.Provider>
  );
}
